import {
    AppstoreOutlined,
    CreditCardFilled,
    ExclamationCircleFilled,
    FallOutlined,
    FileAddOutlined,
    FilePdfFilled,
    FileProtectOutlined,
    PauseCircleOutlined,
    PlusOutlined,
    ReloadOutlined,
    RiseOutlined,
    FilterOutlined,
    DownloadOutlined,
} from "@ant-design/icons";
import {
    Badge,
    Button,
    Card,
    Col,
    ConfigProvider,
    DatePicker,
    Form,
    Input,
    Modal,
    Row,
    Select,
    Slider,
    Space,
    Spin,
    Switch,
    Table,
    Tabs,
    Tag,
} from "antd";
import { Footer } from "antd/es/layout/layout";
import frFR from "antd/locale/fr_FR";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import { rightsService } from "../../services/rightsService";
import axiosInstance from "../../variables/api/axiosInstance";
import { LOGGED_USER } from "../../variables/constants";
import {
    frenchDate,
    frenchDateSimple,
    getDateSouscription,
} from "../../variables/functions";
import AttestationMoto from "./components/docs/AttestationMoto";
import AttestationMotoToPrint from "./components/docs/AttestationMotoToPrint";
import DTRFFormat from "./components/docs/DTRFFormat";
import { displayNumbers } from "../../variables/numbersFunctions";
import { searchProduction } from "../../hooks/useSearch";
import { renderContratSearchResults } from "./components/ContratSearchResults";
import dayjs from "dayjs";
import { StatCard } from "../../components/statistics/StatCard";
import { COLORS } from "../../components/ui/colors";

const { confirm } = Modal;
const { Option } = Select;
const { RangePicker } = DatePicker;

const dateFormat = "DD/MM/YYYY";

const Production = () => {
    // Filtres persistés : lus À CHAQUE MONTAGE (init paresseuse) → restaurés AVANT le 1er rendu.
    // Survit au retour depuis le détail d'un contrat + reload.
    const SAVED_PROD_FILTERS = useMemo(() => {
        try { return JSON.parse(sessionStorage.getItem("filters:production") || "null") || {}; }
        catch (e) { return {}; }
    }, []);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(SAVED_PROD_FILTERS.currentPage ?? 1);
    const [pageSize, setPageSize] = useState(SAVED_PROD_FILTERS.pageSize ?? 10);
    const [data, setData] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [hidden, setHidden] = useState(false);
    const [selectedContrats, setSelectedContrats] = useState([]);
    const [loadingContrats, setLoadingContrats] = useState(true);
    const [membres, setMembres] = useState([]);
    const [filteredInfo, setFilteredInfo] = useState(SAVED_PROD_FILTERS.filteredInfo ?? {});
    const [sortedInfo, setSortedInfo] = useState(SAVED_PROD_FILTERS.sortedInfo ?? {});
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [numAttestationModal, setNumAttestationModal] = useState(false);
    const [printingAttestation, setPrintingAttestation] = useState(false);
    const [numeroAttestations, setNumeroAttestations] = useState([]);
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [numeroPaiement, setNumeroPaiement] = useState("P");
    const [modePaiement, setModePaiement] = useState("");
    const [contractsToPay, setContractsToPay] = useState([]);
    const [contractToPay, setContractToPay] = useState();
    const [modePaiementForm] = Form.useForm();
    const [banques, setBanques] = useState([]);
    const [banque, setBanque] = useState("BANQUE");
    const [currentContractIndex, setCurrentContractIndex] = useState(0);
    const [count, setCount] = useState("");
    const [ecritures, setEcritures] = useState([]);
    const [loadingEcritures, setLoadingEcritures] = useState({});
    const [searchResults, setSearchResults] = useState([]);
    const [searchValue, setSearchValue] = useState("");



    // État pour gérer l'onglet actif
    const [activeTab, setActiveTab] = useState(SAVED_PROD_FILTERS.activeTab ?? "6");
    const [selectedDate, setSelectedDate] = useState(Array.isArray(SAVED_PROD_FILTERS.selectedDate) ? SAVED_PROD_FILTERS.selectedDate : null);
    const [selectedCompagnies, setSelectedCompagnies] = useState(Array.isArray(SAVED_PROD_FILTERS.selectedCompagnies) ? SAVED_PROD_FILTERS.selectedCompagnies : []);
    const [pagination, setPagination] = useState({
        current: SAVED_PROD_FILTERS.currentPage ?? 1,
        pageSize: SAVED_PROD_FILTERS.pageSize ?? 10,
        showSizeChanger: true,
    });

    // Persistance des filtres : sauvegarde à chaque changement (restauration via init paresseuse
    // ci-dessus). selectedDate est déjà un tableau de chaînes "YYYY-MM-DD" → JSON direct.
    useEffect(() => {
        try {
            sessionStorage.setItem("filters:production", JSON.stringify({
                filteredInfo, sortedInfo, currentPage, pageSize, activeTab, selectedDate, selectedCompagnies,
            }));
        } catch (e) { /* quota / sérialisation */ }
    }, [filteredInfo, sortedInfo, currentPage, pageSize, activeTab, selectedDate, selectedCompagnies]);

    const columns = [
        {
            title: "Numero de police",
            dataIndex: "numeroPolice",
            key: "1",
        },
        {
            title: "Souscripteur",
            dataIndex: "souscripteur",
            key: "2",
        },
        {
            title: "Organisme",
            dataIndex: "organisme",
            key: "3",
        },
        {
            title: "Date souscription",
            dataIndex: "dateSouscription",
            key: "dateSouscription",
        },
        {
            title: "Date Effet",
            dataIndex: "dateEffet",
            key: "4",
        },
        {
            title: "Date Echeance",
            dataIndex: "dateEcheance",
            key: "5",
        },
        {
            title: "Avenant",
            dataIndex: "codeAvenant",
            key: "avenant",
            render: (_, record) => {
                const map = {
                    AN: { label: "Affaire nouvelle", color: "blue" },
                    RN: { label: "Renouvellement", color: "geekblue" },
                    AG: { label: "Augmentation", color: "green" },
                    DG: { label: "Diminution", color: "orange" },
                    IN: { label: "Incorporation", color: "cyan" },
                    PR: { label: "Prorogation", color: "purple" },
                    TG: { label: "Transfert", color: "magenta" },
                    RV: { label: "Remise en vigueur", color: "lime" },
                    RT: { label: "Retrait véhicule", color: "volcano" },
                    SP: { label: "Suspension", color: "gold" },
                    RS: { label: "Résiliation", color: "red" },
                    AD: { label: "Duplicata", color: "default" },
                    AO: { label: "Avenant d'ordre", color: "default" },
                };
                const code = record.codeAvenant;
                const cfg = map[code];
                return (
                    <Tag color={cfg?.color || "default"} style={{ fontWeight: 500 }}>
                        {cfg?.label || record.avenant || code || "—"}
                    </Tag>
                );
            },
        },
        {
            title: "Statut reg.",
            dataIndex: "regle",
            key: "regle",
            render: (_, record) => (
                <>
                    {record.regle === "REGLE" ? (
                        <Tag color="success" key={_} style={{ fontWeight: 500, padding: '4px 12px' }}>
                            REGLE
                        </Tag>
                    ) : (
                        <Tag color="processing" key={_} style={{ fontWeight: 500, padding: '4px 12px' }}>
                            NON REGLE
                        </Tag>
                    )}
                </>
            ),
            filters: [
                {
                    text: "REGLE",
                    value: "REGLE",
                },
                {
                    text: "NON REGLE",
                    value: "NON REGLE",
                },
            ],
            filteredValue: filteredInfo.regle || null,
            onFilter: (value, record) => record.regle === value,
            sorter: (a, b) => a.regle.length - b.regle.length,
            sortOrder: sortedInfo.columnKey === "regle" ? sortedInfo.order : null,
            ellipsis: true,
        },
        {
            title: "Prime nette",
            dataIndex: "primeNette",
            key: "primeNette",
        },
        {
            title: "Accessoires",
            dataIndex: "accessoires",
            key: "accessoires",
        },
        {
            title: "Taxes",
            dataIndex: "taxes",
            key: "taxes",
        },
        {
            title: "Prime TTC",
            dataIndex: "primeTotale",
            key: "primeTotale",
        },
        Table.EXPAND_COLUMN,
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <Space size="small">
                    <button
                        type="button"
                        class="btn btn-primary btn-icon rounded-pill"
                        onClick={() => navigate(`/details-contrat/${record.codeId}`)}
                        style={{
                            backgroundColor: '#1890ff',
                            borderColor: '#1890ff',
                            boxShadow: '0 2px 4px rgba(24, 144, 255, 0.2)'
                        }}
                    >
                        <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                </Space>
            ),
        },
    ];

    const printRef = useRef();

    const navigate = useNavigate();

    const handleChange = (pagination, filters, sorter) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        setPagination(pagination);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const handleDateChange = (dates, dateStrings) => {
        const [sDate, eDate] = dateStrings;
        const [startDay, startMonth, startYear] = sDate.split("/");
        const [endDay, endMonth, endYear] = eDate.split("/");
        const startDate = `${startYear}-${startMonth}-${startDay}`;
        const endDate = `${endYear}-${endMonth}-${endDay}`;
        console.table([startDate, endDate]);
        setSelectedDate([startDate, endDate]);
        setFilteredInfo({
            ...filteredInfo,
            startDate,
            endDate,
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                startDate,
                endDate,
            },
        });
    };

    const fetchData = async (params = {}) => {
        setLoadingContrats(true);
        try {
            const response = await axiosInstance.get("/api/contrat", {
                params: {
                    page: params.pagination.current - 1,
                    size: params.pagination.pageSize,
                    ...params.filters,
                    compagnie: params.filters?.compagnie?.join(','),
                    // Recherche par CLÉ (les clés ne sont plus contiguës après fusion des tabs)
                    avenant: (tabsDefinition.find((t) => String(t.key) === String(activeTab)) || {}).avenant,
                    // Onglet « Tous les contrats » (clé 6) : on masque les propositions (elles restent
                    // consultables dans l'onglet « Proposition ») et le backend trie alors par date de
                    // souscription. Les autres onglets restent inchangés.
                    exclurePropositions: String(activeTab) === "6" ? true : undefined,
                },
            });
            const { content, totalElements } = response.data;

            let ctrs = [];
            content.forEach((contrat, key) => {
                ctrs.push({
                    key: contrat.codeId,
                    codeId: contrat.codeId,
                    id: key,
                    numeroPolice: contrat.numeroPoliceM
                        ? contrat.numeroPoliceM
                        : contrat.numeroPoliceP,
                    numeroPoliceP: contrat.numeroPoliceP,
                    souscripteur: contrat?.prenom
                        ? ` ${contrat?.nom} ${contrat?.prenom}`
                        : `${contrat?.nom}`,
                    organisme: contrat?.raisonSociale,
                    dateSouscription: getDateSouscription(contrat)
                        ? `${frenchDate(getDateSouscription(contrat))}`
                        : "",
                    dateEffet: contrat?.dateEffet
                        ? `${frenchDate(contrat?.dateEffet)}`
                        : "",
                    dateEcheance: contrat?.dateEcheance
                        ? `${frenchDateSimple(contrat?.dateEcheance)} `
                        : "",
                    regle: contrat.reglements > 0 ? "REGLE" : "NON REGLE",
                    codeAvenant: contrat?.codeAvenant,
                    avenant: contrat?.avenant,
                    primeTotale: displayNumbers(contrat?.primeTotale),
                    taxes: displayNumbers(contrat?.primeTotale * 0.06 / 1.06),
                    primeNette: displayNumbers(contrat?.primeNetteFractionnee ? contrat?.primeNetteFractionnee : contrat?.primeNette),
                    accessoires: contrat?.primeNetteFractionnee ? `Inclus dans P.N.` : displayNumbers(contrat?.accessoires),
                    data: contrat,
                });
            });
            setData(ctrs);
            setPagination({
                ...params.pagination,
                total: totalElements,
            });
            setTotal(totalElements);
        } catch (error) {
            console.error("Failed to fetch data:", error);
        } finally {
            setLoadingContrats(false);
        }
    };

    const exportDataToExcel = async () => {
        if (!selectedDate) {
            toast("Veuillez sélectionner une période!");
            return;
        }
        setLoadingContrats(true);
        try {
            const startDate = selectedDate[0];
            const endDate = selectedDate[1];
            // L'Excel est désormais généré et streamé par le serveur (/export/excel) :
            // plus de JSON volumineux à charger ni de construction côté navigateur (cf. ancien /all → 500).
            const response = await axiosInstance.get("/api/contrat/export/excel", {
                params: {
                    startDate,
                    endDate,
                    compagnie: selectedCompagnies?.join(','),
                },
                responseType: "blob",
            });
            downloadBlobAsFile(response?.data, "ListingPolices.xlsx");
        } catch (err) {
            console.error(err);
            toast("Échec de l'export. Réessayez, ou réduisez la période sélectionnée.");
        } finally {
            setLoadingContrats(false);
        }
    }

    useEffect(() => {
        if (selectedDate || selectedCompagnies) {
            if (selectedDate) {
                const startDate = selectedDate[0];
                const endDate = selectedDate[1];
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        startDate,
                        endDate,
                        compagnie: selectedCompagnies
                    },
                });
            } else {
                fetchData({
                    pagination,
                    filters: {
                        ...filteredInfo,
                        compagnie: selectedCompagnies
                    },
                });
            }

        } else {
            fetchData({
                pagination,
                filteredInfo,
            });
        }

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/organisme/assurance`)
            .then((res) => {
                let membs = [];
                res.data.forEach((memb, index) => {
                    membs.push({
                        key: index,
                        text: memb.raisonSociale,
                        value: memb.code,
                        data: memb,
                    });
                });
                membs.push({
                    key: "DTRF",
                    text: "DTRF",
                    value: "DTRF",
                });
                membs.push({
                    key: "DTRF-Lome",
                    text: "DTRF-LOME",
                    value: "LOME",
                });
                membs.push({
                    key: "DTRF-Kpalime",
                    text: "DTRF-KPALIME",
                    value: "KPALIME",
                });
                membs.push({
                    key: "DTRF-Atakpame",
                    text: "DTRF-ATAKPAME",
                    value: "ATAKPAME",
                });
                membs.push({
                    key: "DTRF-Sokode",
                    text: "DTRF-SOKODE",
                    value: "SOKODE",
                });
                membs.push({
                    key: "DTRF-Kara",
                    text: "DTRF-KARA",
                    value: "KARA",
                });
                membs.push({
                    key: "DTRF-Dapaong",
                    text: "DTRF-DAPAONG",
                    value: "DAPAONG",
                });
                membs.push({
                    key: "STCA",
                    text: "STCA",
                    value: "STCA",
                });
                setMembres(membs);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/contrat/count`)
            .then((res) => {
                setCount(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [currentPage, pageSize, selectedDate, activeTab]);

    const filteringOnCompanies = (companies) => {
        setSelectedCompagnies(companies);
        setFilteredInfo({
            ...filteredInfo,
            compagnie: companies
        });
        fetchData({
            pagination,
            filters: {
                ...filteredInfo,
                compagnie: companies
            },
        });
    };

    const attestationRefs = useRef(selectedContrats.map(() => React.createRef()));
    const printedAttestationRefs = useRef(
        selectedContrats.map(() => React.createRef()),
    );

    const MyFooter = () => {
        let ctrt = selectedRows.find((ctr) => ctr.regle === "NON REGLE");
        let rCtrts = selectedRows.filter((ctr) => ctr.regle === "REGLE");
        let nrCtrts = selectedRows.filter((ctr) => ctr.regle === "NON REGLE");
        return (
            <div class="row" style={{ padding: '16px 0' }}>
                {ctrt ? (
                    <div class="col-sm-4">
                        <Button
                            onClick={() => {
                                encaisserContrats(nrCtrts);
                            }}
                            type="primary"
                            icon={<CreditCardFilled />}
                            size="large"
                            style={{
                                backgroundColor: '#52c41a',
                                borderColor: '#52c41a',
                                fontWeight: 500,
                                boxShadow: '0 4px 12px rgba(82, 196, 26, 0.3)'
                            }}
                            title="Encaissement"
                        >
                            Encaisser
                        </Button>
                    </div>
                ) : (
                    <>
                        <div class="col-sm-4">
                            <Button
                                onClick={() => {
                                    exportToPdfs(rCtrts);
                                }}
                                type="primary"
                                icon={<FilePdfFilled />}
                                size="large"
                                style={{
                                    backgroundColor: '#242166',
                                    borderColor: '#242166',
                                    fontWeight: 500,
                                    boxShadow: '0 4px 12px rgba(36, 33, 102, 0.3)'
                                }}
                            >
                                Imprimer C.P.
                            </Button>
                        </div>
                        <div class="col-sm-4">
                            <Button
                                onClick={() => {
                                    exportAttestations(rCtrts);
                                }}
                                type="primary"
                                icon={<FileProtectOutlined />}
                                size="large"
                                style={{
                                    backgroundColor: '#1890ff',
                                    borderColor: '#1890ff',
                                    fontWeight: 500,
                                    boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
                                }}
                            >
                                Imprimer Attestation
                            </Button>
                        </div>
                    </>
                )}
            </div>
        );
    };


    const encaisserContrats = (cts) => {
        setModalModePaiement(true);
        setContractsToPay(cts);
    };

    const encaisserContrat = (id) => {
        setModalModePaiement(true);
        setContractToPay(id);
    };

    const alertReglement = (contractToPay) => {
        confirm({
            title: "Etes-vous sûr de vouloir régler ce contrat?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementContrat(contractToPay);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const reglementContrat = (id) => {
        if (modePaiement === "ESPECES") {
            axiosInstance
                .get(
                    `/api/reglement/especes/contrat/codeId/${id}/${LOGGED_USER.codeId}`,
                )
                .then((res) => {
                    window.location.reload();
                    toast("Reglement effectué avec succès!");
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        } else if (modePaiement === "BANQUE" || modePaiement === "MOBILE_MONEY") {
            axiosInstance
                .get(
                    `/api/reglement/contrat/codeId/${id}/${LOGGED_USER.codeId}/${modePaiement}/${numeroPaiement}/${banque}`,
                )
                .then((res) => {
                    window.location.reload();
                    toast("Règlement effectué avec succès!");
                    res.data = null;
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        }
    };

    const alertReglements = (cts) => {
        confirm({
            title: "Etes-vous sûr de vouloir régler ces contrats?",
            icon: <ExclamationCircleFilled />,
            content: "Toutes vos actions sont historisées!",
            okText: "Oui régler",
            okType: "danger",
            cancelText: "Annuler",
            onOk() {
                console.log("OK");
                reglementsContrats(cts);
            },
            onCancel() {
                console.log("Cancel");
            },
        });
    };

    const reglementsContrats = (contrats) => {
        var allContrats = [];
        contrats.forEach((ctrt) => {
            allContrats.push(ctrt.data);
        });
        if (modePaiement === "ESPECES") {
            axiosInstance
                .post(`/api/reglement/especes/contrats`, JSON.stringify(allContrats))
                .then((res) => {
                    window.location.reload();
                    toast("Règlements effectués avec succès!");
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        } else if (modePaiement === "BANQUE" || modePaiement === "MOBILE_MONEY") {
            axiosInstance
                .post(
                    `/api/reglement/else/${modePaiement}/${numeroPaiement}/${banque}`,
                    JSON.stringify(allContrats),
                )
                .then((res) => {
                    window.location.reload();
                    toast("Règlements effectués avec succès!");
                })
                .catch((err) => {
                    console.log(err);
                    toast("Erreur lors du règlement");
                });
        }
    };

    const exportAttestations = (contrats) => {
        setNumAttestationModal(true);
        setSelectedContrats(contrats);
    };

    const attestationPrinting = () => {
        selectedContrats.forEach((aContrat, index) => {
            exportAttestationToPdf();
        });
    };

    const exportAttestationToPdf = useReactToPrint({
        content: () => attestationRefs.current[currentContractIndex]?.current,
        onBeforeGetContent: () => setPrintingAttestation(false),
        onAfterPrint: () => {
            setCurrentContractIndex((prevIndex) => prevIndex + 1);
        },
    });

    useEffect(() => {
        if (currentContractIndex < selectedContrats.length) {
            exportAttestationToPdf();
        } else {
            setCurrentContractIndex(0);
        }
    }, [currentContractIndex]);

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    const exportToPdfs = (contrats) => {
        setSelectedContrats(contrats);
        setHidden(true);
        setTimeout(() => {
            handlePrint();
            contrats.forEach((ctrt) => {
                axiosInstance
                    .get(
                        `/api/contrat/impression/codeId/${ctrt.codeId}/${LOGGED_USER.codeId}`,
                    )
                    .then((res) => {
                        console.log("OK");
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            });
        }, [500]);
    };

    const onSelectChange = (newSelectedRowKeys, rows) => {
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    const pbStyles = {
        pageBreak: {
            pageBreakBefore: "always",
        },
    };


    // Déclenche le téléchargement d'un blob reçu du serveur (fichier .xlsx déjà construit).
    const downloadBlobAsFile = (blob, fileName) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    const getEcritures = async (numeroPolice) => {
        return await axiosInstance
            .get(`/api/details-ecriture/ecriture/numeroPolice/${numeroPolice}`)
            .then((res) => {
                setEcritures(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }

    // Définition des onglets avec badges de comptage
    const tabsDefinition = [
        {
            key: "1",
            label: (
                <span>
                    <FileAddOutlined /> Affaires nouvelles
                    <Badge count={count?.avenantANCount} style={{ marginLeft: 8, backgroundColor: '#52c41a' }} />
                </span>
            ),
            avenant: "AN",
        },
        {
            key: "3",
            label: (
                <span>
                    <RiseOutlined /> Avenants positifs
                    <Badge count={count.primePositiveCount} style={{ marginLeft: 8, backgroundColor: '#52c41a' }} />
                </span>
            ),
            avenant: "P",
        },
        {
            key: "4",
            label: (
                <span>
                    <FallOutlined /> Avenants négatifs
                    <Badge count={count.primeNegativeCount} style={{ marginLeft: 8, backgroundColor: '#ff4d4f' }} />
                </span>
            ),
            avenant: "N",
        },
        {
            key: "5",
            label: (
                <span>
                    <PauseCircleOutlined /> Suspensions
                    <Badge count={count.avenantSPCount} style={{ marginLeft: 8, backgroundColor: '#faad14' }} />
                </span>
            ),
            avenant: "SP",
        },
        {
            key: "6",
            label: (
                <span>
                    <AppstoreOutlined /> Tous les contrats
                    <Badge count={count.totalContrats} style={{ marginLeft: 8, backgroundColor: '#242166' }} />
                </span>
            ),
            avenant: null,
        },
    ];

    const renderSearchResults = (results) => renderContratSearchResults(results, searchValue, navigate);

    useEffect(() => {
        // Debounce : on n'interroge le serveur que 400ms après la dernière frappe
        if (!searchValue || searchValue.length <= 2) {
            setSearchResults([]);
            return;
        }
        const handler = setTimeout(() => {
            searchProduction(searchValue).then((res) => {
                setSearchResults(res.data.content);
            }).catch((err) => {
                console.log(err);
            });
        }, 400);
        return () => clearTimeout(handler);
    }, [searchValue]);


    return (
        <div class="layout-wrapper layout-content-navbar">
            <div class="layout-container">
                <SideBar currentMenu={"PRODUCTION"} />

                <div class="layout-page">
                    <NavBar
                        filteredResults={searchResults}
                        setFilteredResults={setSearchResults}
                        renderSearchResults={renderSearchResults}
                        searchValue={searchValue}
                        setSearchValue={setSearchValue}
                    />

                    <div class="content-wrapper" style={{ backgroundColor: '#f5f7fa' }}>
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <Row style={{ marginBottom: "15px", justifyContent: "space-between" }}>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats"
                                        subtitle="Total contrats"
                                        value={displayNumbers(total || 0)}
                                        icon="bx bx-file"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats validés"
                                        subtitle="Nbre total actifs / Nbre total validés"
                                        value={`${count?.activeCount ? displayNumbers(count?.activeCount) : 0} / ${count?.valideCount ? displayNumbers(count?.valideCount) : 0}`}
                                        icon="bx bx-check-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats annulés"
                                        subtitle="Contrats annulés"
                                        value={displayNumbers(count?.annuleCount || 0)}
                                        icon="bx bx-x-circle"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Contrats en attente"
                                        subtitle="Contrats en Proposition"
                                        value={displayNumbers(count?.enPropositionCount || 0)}
                                        icon="bx bx-time-five"
                                        iconBg={COLORS.secondary}
                                        gradient={COLORS.secondary}
                                    />
                                </Col>
                            </Row>

                            {/* Boutons d'action */}
                            <div class="row" style={{ marginBottom: '24px' }}>
                                <div class="col-sm-4">
                                    {rightsService("HCO022") ||
                                        rightsService("HCO005") ||
                                        rightsService("HCO019") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            onClick={() => navigate("/ajouter-contrat-new")}
                                            style={{
                                                backgroundColor: '#242166',
                                                borderColor: '#242166',
                                                fontWeight: 500,
                                                height: '44px',
                                                borderRadius: '8px',
                                                boxShadow: '0 4px 12px rgba(36, 33, 102, 0.3)'
                                            }}
                                        >
                                            Nouveau contrat
                                        </Button>
                                    ) : null}
                                </div>
                                <div class="col-sm-4">
                                    {rightsService("HLA078") ? (
                                        <Button
                                            type="primary"
                                            icon={<PlusOutlined />}
                                            onClick={() => navigate("/ancien-contrat-gum")}
                                            style={{
                                                backgroundColor: '#595959',
                                                borderColor: '#595959',
                                                fontWeight: 500,
                                                height: '44px',
                                                borderRadius: '8px',
                                                boxShadow: '0 4px 12px rgba(89, 89, 89, 0.3)'
                                            }}
                                        >
                                            Ajouter Ancien contrat GUM
                                        </Button>
                                    ) : null}
                                </div>
                                <div class="col-sm-4">
                                    {/* Accès à la nouvelle production (v2) — phase de test/validation */}
                                    <Button
                                        type="primary"
                                        icon={<AppstoreOutlined />}
                                        onClick={() => navigate("/production/v2")}
                                        style={{
                                            backgroundColor: '#0d9488',
                                            borderColor: '#0d9488',
                                            fontWeight: 500,
                                            height: '44px',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 12px rgba(13, 148, 136, 0.3)'
                                        }}
                                    >
                                        Tester la nouvelle vue production (v2)
                                    </Button>
                                </div>
                            </div>

                            {/* Card principale avec filtres */}
                            <div class="card" style={{
                                borderRadius: '12px',
                                border: 'none',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.08)'
                            }}>
                                <div class="container">
                                    <div class="card" style={{
                                        marginTop: '24px',
                                        borderRadius: '8px',
                                        backgroundColor: '#fafbfc',
                                        border: '1px solid #e8e8e8'
                                    }}>
                                        <div class="card-body">
                                            <div class="row align-items-center">
                                                <div class="col-12 col-md-4 mb-3 mb-md-0">
                                                    <Space align="center">
                                                        <span style={{ fontWeight: 500, color: '#595959' }}>Mode sélection:</span>
                                                        <Switch
                                                            checked={selecting}
                                                            onChange={setSelecting}
                                                            style={{
                                                                backgroundColor: selecting ? '#242166' : undefined
                                                            }}
                                                        />
                                                    </Space>
                                                </div>
                                                <div class="col-12 col-md-4 mb-3 mb-md-0">
                                                    <RangePicker
                                                        format={dateFormat}
                                                        value={Array.isArray(selectedDate) && selectedDate[0] && selectedDate[1]
                                                            ? [dayjs(selectedDate[0]), dayjs(selectedDate[1])] : null}
                                                        onChange={handleDateChange}
                                                        placeholder={["Date début", "Date fin"]}
                                                        style={{
                                                            width: '100%',
                                                            borderRadius: '6px',
                                                            borderColor: '#d9d9d9'
                                                        }}
                                                        suffixIcon={<FilterOutlined style={{ color: '#242166' }} />}
                                                    />
                                                </div>
                                                {LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" && (LOGGED_USER?.agence?.typeAgence === "SIEGE" || LOGGED_USER?.agence === null) ?
                                                    <div class="col-12 col-md-4">
                                                        <Select
                                                            mode="multiple"
                                                            placeholder="Filtrer par compagnie"
                                                            value={selectedCompagnies}
                                                            onChange={filteringOnCompanies}
                                                            options={membres.map((memb) => (
                                                                {
                                                                    label: memb.text,
                                                                    value: memb.value,
                                                                    key: memb.value
                                                                }
                                                            ))}
                                                            style={{ width: "100%" }}
                                                            suffixIcon={<FilterOutlined style={{ color: '#242166' }} />}
                                                        />
                                                    </div> : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Onglets avec tableau */}
                                <Card
                                    className="main-card-pro"
                                    bordered={false}
                                    style={{ marginTop: '24px' }}
                                >
                                    <ConfigProvider
                                        locale={frFR}
                                        theme={{
                                            token: {
                                                colorPrimary: '#242166',
                                            },
                                        }}
                                    >
                                        <Spin spinning={loadingContrats}>
                                            <Tabs
                                                activeKey={activeTab}
                                                onChange={setActiveTab}
                                                className="custom-tabs-pro"
                                                size="large"
                                                items={tabsDefinition.map(({ key, label }) => ({
                                                    key,
                                                    label: label,
                                                    children: (
                                                        <div className="tab-content-wrapper-pro">
                                                            <Table
                                                                rowSelection={selecting ? rowSelection : null}
                                                                expandable={{
                                                                    onExpand: (expanded, record) => {
                                                                        const police = record.numeroPoliceP;

                                                                        if (expanded) {
                                                                            setLoadingEcritures((prev) => ({ ...prev, [police]: true }));

                                                                            getEcritures(police).finally(() => {
                                                                                setLoadingEcritures((prev) => ({ ...prev, [police]: false }));
                                                                            });
                                                                        }
                                                                    },
                                                                    expandedRowRender: (record) => {
                                                                        const police = record.numeroPoliceP;

                                                                        if (loadingEcritures[police]) {
                                                                            return (
                                                                                <div style={{ padding: "16px", textAlign: "center" }}>
                                                                                    <Spin size="small" /> Chargement des écritures comptables...
                                                                                </div>
                                                                            );
                                                                        }

                                                                        const groupedEcritures = ecritures
                                                                            .filter(e => e.ecriture?.numeroPolice === police)
                                                                            .reduce((acc, ecriture) => {
                                                                                const codeId = ecriture.ecriture.codeId;
                                                                                if (!acc[codeId]) acc[codeId] = [];
                                                                                acc[codeId].push(ecriture);
                                                                                return acc;
                                                                            }, {});
                                                                        const ecrituresGrouppees = Object.values(groupedEcritures);
                                                                        return ecrituresGrouppees?.length > 0 ? (
                                                                            ecrituresGrouppees?.map((ec, idx) => (
                                                                                <div style={{
                                                                                    padding: "20px",
                                                                                    backgroundColor: '#fafafa',
                                                                                    borderRadius: '8px',
                                                                                    marginBottom: '16px'
                                                                                }} key={idx}>
                                                                                    <p style={{
                                                                                        fontWeight: 600,
                                                                                        color: '#242166',
                                                                                        marginBottom: '16px',
                                                                                        fontSize: '15px'
                                                                                    }}>
                                                                                        <strong>Écriture comptable : {ec[0]?.ecriture?.libelle}</strong>
                                                                                    </p>
                                                                                    <table className="table table-bordered" style={{
                                                                                        width: "100%",
                                                                                        marginBottom: "8px",
                                                                                        backgroundColor: '#fff',
                                                                                        borderRadius: '6px',
                                                                                        overflow: 'hidden'
                                                                                    }}>
                                                                                        <thead style={{ backgroundColor: '#242166' }}>
                                                                                            <tr>
                                                                                                <th colSpan={2} style={{ color: '#fff', padding: '12px' }}>COMPTES</th>
                                                                                                <th style={{ color: '#fff', padding: '12px' }}></th>
                                                                                                <th colSpan={2} style={{ color: '#fff', padding: '12px' }}>MONTANT</th>
                                                                                            </tr>
                                                                                            <tr style={{ backgroundColor: '#2f2a7a' }}>
                                                                                                <th style={{ color: '#fff', padding: '10px' }}>DEBIT</th>
                                                                                                <th style={{ color: '#fff', padding: '10px' }}>CREDIT</th>
                                                                                                <th style={{ color: '#fff', padding: '10px' }}>LIBELLE</th>
                                                                                                <th style={{ color: '#fff', padding: '10px' }}>DEBIT</th>
                                                                                                <th style={{ color: '#fff', padding: '10px' }}>CREDIT</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {ec.map((ecr, indx) => (
                                                                                                <tr key={indx} style={{
                                                                                                    borderBottom: '1px solid #f0f0f0'
                                                                                                }}>
                                                                                                    <td style={{ padding: '10px' }}>{ecr?.debit ? ecr?.compte?.numeroCompte : ""}</td>
                                                                                                    <td style={{ padding: '10px' }}>{ecr?.credit ? ecr?.compte?.numeroCompte : ""}</td>
                                                                                                    <td style={{ padding: '10px' }}>{ecr?.libelle}</td>
                                                                                                    <td style={{ padding: '10px', fontWeight: 500 }}>{ecr?.debit ? displayNumbers(ecr?.debit) : ""}</td>
                                                                                                    <td style={{ padding: '10px', fontWeight: 500 }}>{ecr?.credit ? displayNumbers(ecr?.credit) : ""}</td>
                                                                                                </tr>
                                                                                            ))}
                                                                                        </tbody>
                                                                                    </table>
                                                                                    <p style={{
                                                                                        fontStyle: "italic",
                                                                                        color: '#595959',
                                                                                        marginTop: '12px',
                                                                                        fontSize: '13px'
                                                                                    }}>
                                                                                        {ec[0]?.ecriture?.libelle}
                                                                                    </p>
                                                                                </div>
                                                                            ))
                                                                        ) : (
                                                                            <p style={{
                                                                                padding: '20px',
                                                                                textAlign: 'center',
                                                                                color: '#8c8c8c'
                                                                            }}>
                                                                                Aucune écriture trouvée
                                                                            </p>
                                                                        );
                                                                    },
                                                                }}
                                                                columns={columns}
                                                                rowKey="codeId"
                                                                dataSource={data}
                                                                onChange={handleChange}
                                                                pagination={pagination}
                                                                scroll={{ x: "max-content" }}
                                                                footer={() => selecting ? <MyFooter /> : null}
                                                                style={{
                                                                    borderRadius: '8px'
                                                                }}
                                                            />
                                                        </div>
                                                    ),
                                                }))}
                                                style={{ marginBottom: 16 }}
                                            />
                                        </Spin>
                                    </ConfigProvider>
                                </Card>
                            </div>

                            <div class="card" id="myContrat" ref={printRef}>
                                {selecting &&
                                    hidden &&
                                    selectedContrats.map((row, index) => (
                                        <DTRFFormat contrat={row.data} key={index} />
                                    ))}
                            </div>
                        </div>

                        {/* Modal des filtres — supprimée */}


                        {/* Modal Mode de paiement */}
                        <Modal
                            title={<span style={{ color: '#242166', fontSize: '18px', fontWeight: 600 }}>Mode de paiement</span>}
                            centered
                            open={modalModePaiement}
                            onOk={() => {
                                selecting
                                    ? alertReglements(contractsToPay)
                                    : alertReglement(contractToPay);
                            }}
                            onCancel={() => {
                                setModalModePaiement(false);
                            }}
                            okText="Valider"
                            cancelText="Annuler"
                            okButtonProps={{
                                style: {
                                    backgroundColor: '#242166',
                                    borderColor: '#242166',
                                    fontWeight: 500
                                }
                            }}
                        >
                            <div className="container" justify="center">
                                <div className="grid-item" lg={12}>
                                    <Form
                                        form={modePaiementForm}
                                        layout="vertical"
                                        name="userForm"
                                    >
                                        <Form.Item
                                            name="modePaiement"
                                            label={<span style={{ fontWeight: 500 }}>Mode de paiement</span>}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: 'Veuillez sélectionner un mode de paiement'
                                                },
                                            ]}
                                        >
                                            <Select
                                                onChange={(value) => {
                                                    setModePaiement(value);
                                                }}
                                                placeholder="Sélectionnez votre mode de paiement"
                                                size="large"
                                            >
                                                <Option value="ESPECES">💵 ESPECES</Option>
                                                <Option value="BANQUE">🏦 BANQUE (Chèque)</Option>
                                                <Option value="MOBILE_MONEY">📱 TMONEY / FLOOZ</Option>
                                            </Select>
                                        </Form.Item>
                                        {modePaiement === "BANQUE" ||
                                            modePaiement === "MOBILE_MONEY" ? (
                                            <Form.Item
                                                name="numeroPaiement"
                                                label={
                                                    <span style={{ fontWeight: 500 }}>
                                                        {modePaiement === "BANQUE"
                                                            ? "Numéro de chèque"
                                                            : modePaiement === "MOBILE_MONEY"
                                                                ? "Numéro FLOOZ / TMONEY"
                                                                : ""}
                                                    </span>
                                                }
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: "Veuillez renseigner le champ!",
                                                    },
                                                ]}
                                            >
                                                <Input
                                                    placeholder={
                                                        modePaiement === "BANQUE"
                                                            ? "Le numéro de chèque"
                                                            : modePaiement === "MOBILE_MONEY"
                                                                ? "Le numéro de téléphone MOOV (FLOOZ) / TOGOCOM (TMONEY)"
                                                                : ""
                                                    }
                                                    onChange={(value) => {
                                                        setNumeroPaiement(value.target.value);
                                                    }}
                                                    size="large"
                                                />
                                            </Form.Item>
                                        ) : null}
                                        {modePaiement === "BANQUE" ? (
                                            <Form.Item
                                                name="banque"
                                                label={<span style={{ fontWeight: 500 }}>Banque</span>}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Veuillez sélectionner une banque'
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    onChange={(value) => {
                                                        setBanque(value);
                                                    }}
                                                    placeholder="Sélectionnez la banque"
                                                    size="large"
                                                >
                                                    {banques.map((b) => (
                                                        <Option
                                                            key={b.parametreId}
                                                            value={b.libelleParametre}
                                                        >
                                                            {b.libelleParametre}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        ) : null}
                                    </Form>
                                </div>
                            </div>
                        </Modal>

                        {/* Modal Attestation */}
                        <Modal
                            title={<span style={{ color: '#242166', fontSize: '18px', fontWeight: 600 }}>Attestations à imprimer</span>}
                            centered
                            open={numAttestationModal}
                            onOk={() => {
                                setNumAttestationModal(false);
                            }}
                            onCancel={() => {
                                setNumAttestationModal(false);
                            }}
                            width={1200}
                            zIndex={2000}
                            footer={[
                                <Button
                                    key="back"
                                    onClick={() => setNumAttestationModal(false)}
                                    size="large"
                                >
                                    Fermer
                                </Button>,
                                <Button
                                    key="print"
                                    onClick={() => {
                                        attestationPrinting();
                                    }}
                                    type="primary"
                                    icon={<FilePdfFilled />}
                                    size="large"
                                    style={{
                                        backgroundColor: '#52c41a',
                                        borderColor: '#52c41a',
                                        fontWeight: 500
                                    }}
                                >
                                    Imprimer
                                </Button>
                            ]}
                        >
                            <div className="container" justify="center">
                                <div className="grid-item" lg={12}>
                                    {selectedContrats.map((row, index) => (
                                        <div key={index}>
                                            <div>
                                                <AttestationMoto
                                                    ref={attestationRefs.current[index]}
                                                    contrat={row.data}
                                                    printing={
                                                        printingAttestation &&
                                                        currentContractIndex === index
                                                    }
                                                />
                                                <div style={{ display: "none" }}>
                                                    <AttestationMotoToPrint
                                                        ref={printedAttestationRefs.current[index]}
                                                        contrat={row.data}
                                                    />
                                                </div>
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                                <br />
                                            </div>
                                            <div style={pbStyles.pageBreak} className="pageBreak">
                                                <hr />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div style={{
                                backgroundColor: '#fafafa',
                                padding: '20px',
                                borderRadius: '8px',
                                marginTop: '20px'
                            }}>
                                <p style={{
                                    fontWeight: 500,
                                    color: '#242166',
                                    marginBottom: '16px'
                                }}>
                                    Veuillez préciser les numéros d'attestations à imprimer
                                </p>
                                <Slider
                                    range
                                    className="slider-main-div"
                                    min={10000}
                                    max={100000}
                                    onChange={(v) => {
                                        setNumeroAttestations(v);
                                    }}
                                    defaultValue={[10000, 100000]}
                                    value={numeroAttestations}
                                    trackStyle={[{ backgroundColor: '#242166' }]}
                                    handleStyle={[
                                        { borderColor: '#242166' },
                                        { borderColor: '#242166' }
                                    ]}
                                />
                            </div>
                        </Modal>

                        <Footer />
                        <div class="content-backdrop fade"></div>
                    </div>
                </div>
            </div>

            <div class="layout-overlay layout-menu-toggle"></div>
            {rightsService("HCO020") ? (
                <Spin spinning={loadingContrats}>
                    <div class="buy-now">
                        <button
                            onClick={() => exportDataToExcel()}
                            class="btn btn-secondary btn-buy-now"
                            style={{
                                backgroundColor: '#242166',
                                borderColor: '#242166',
                                fontWeight: 500,
                                fontSize: '15px',
                                padding: '9px 24px',
                                borderRadius: '10px',
                                boxShadow: '0 6px 20px rgba(36, 33, 102, 0.4)',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <DownloadOutlined style={{ fontSize: '18px' }} />
                            Exporter
                        </button>
                    </div>
                </Spin>
            ) : null}
            <div class="drag-target"></div>
        </div>
    );
};

export default Production;